// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HybridEnrollmentResultModel {
    static getAttributeTypeMap() {
        return HybridEnrollmentResultModel.attributeTypeMap;
    }
}
HybridEnrollmentResultModel.discriminator = undefined;
HybridEnrollmentResultModel.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
    {
        "name": "pin",
        "baseName": "pin",
        "type": "string"
    },
    {
        "name": "medicalPayerId",
        "baseName": "medicalPayerId",
        "type": "string"
    },
    {
        "name": "medicalMemberNumber",
        "baseName": "medicalMemberNumber",
        "type": "string"
    },
    {
        "name": "medicalGroupNumber",
        "baseName": "medicalGroupNumber",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "string"
    },
    {
        "name": "cardActivationDate",
        "baseName": "cardActivationDate",
        "type": "Date"
    },
    {
        "name": "cardEndDate",
        "baseName": "cardEndDate",
        "type": "Date"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "cardLastFourDigits",
        "baseName": "cardLastFourDigits",
        "type": "string"
    }
];
//# sourceMappingURL=hybridEnrollmentResultModel.js.map